import { api } from './api'

export async function uploadImage(file: File): Promise<string | null> {
  const formData = new FormData()
  formData.append('image', file)

  const res = await api.post('aws/imageUpload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 30000,
  })

  return res?.data?.data?.imageUrl || null
}

